<ng-container *ngIf="{main: main$ | async, favorites: favorites$ | async, activeIds: activeIds$ | async, starred: starredKeys$ | async} as vm">
  <ul class="navbar-nav mr-auto menu-items sn-top-menu">
    <ng-content></ng-content>

    <ng-container *ngIf="!compact; else compactMenu">
      <li *ngIf="vm.favorites?.length" class="nav-item dropdown collapsible-nav-item sn-top-menu__favorites"
          [class.show]="openId === FAVORITES"
          (mouseenter)="hoverOpen(FAVORITES)" (mouseleave)="hoverClose(FAVORITES)">
        <button type="button" class="nav-link dropdown-toggle sn-top-menu__toggle" [attr.data-sn-toggle]="FAVORITES"
                aria-haspopup="true" [attr.aria-expanded]="openId === FAVORITES" aria-label="Favorites" title="Favorites"
                (click)="toggle(FAVORITES)" (keydown)="onToggleKeydown($event, FAVORITES)">
          <i class="fa-solid fa-star" aria-hidden="true"></i>
        </button>
        <div class="dropdown-menu sn-top-dropdown" [attr.data-sn-menu]="FAVORITES">
          <ng-container *ngTemplateOutlet="favoriteItems; context: {$implicit: vm.favorites}"></ng-container>
        </div>
      </li>

      <ng-container *ngFor="let node of vm.main; trackBy: trackById">
        <li *ngIf="node.type === 'link'" class="nav-item collapsible-nav-item">
          <a *ngIf="!node.external" class="nav-link" [class.active-link]="vm.activeIds.has(node.id)"
             [attr.aria-current]="vm.activeIds.has(node.id) ? 'page' : null"
             [routerLink]="node.path" [queryParams]="node.queryParams">{{ node.label | uppercase }}</a>
          <a *ngIf="node.external" class="nav-link" [href]="node.href" target="_blank" rel="noopener noreferrer">
            {{ node.label | uppercase }}<span class="sr-only"> (opens in a new tab)</span>
          </a>
        </li>
        <li *ngIf="node.type === 'group'" class="nav-item dropdown collapsible-nav-item"
            [class.show]="openId === node.id"
            (mouseenter)="hoverOpen(node.id)" (mouseleave)="hoverClose(node.id)">
          <button type="button" class="nav-link dropdown-toggle sn-top-menu__toggle" [attr.data-sn-toggle]="node.id"
                  [class.active-link]="vm.activeIds.has(node.id)" aria-haspopup="true"
                  [attr.aria-expanded]="openId === node.id"
                  (click)="toggle(node.id)" (keydown)="onToggleKeydown($event, node.id)">
            {{ node.label | uppercase }}
          </button>
          <div class="dropdown-menu sn-top-dropdown" [attr.data-sn-menu]="node.id">
            <ng-container *ngTemplateOutlet="items; context: {$implicit: node.children, vm: vm}"></ng-container>
          </div>
        </li>
      </ng-container>
    </ng-container>

    <ng-template #compactMenu>
      <li class="nav-item dropdown top-menus-overflow" [class.show]="openId === COMPACT"
          (mouseenter)="hoverOpen(COMPACT)" (mouseleave)="hoverClose(COMPACT)">
        <button type="button" class="nav-link dropdown-toggle sn-top-menu__toggle" [attr.data-sn-toggle]="COMPACT"
                aria-haspopup="true" [attr.aria-expanded]="openId === COMPACT"
                (click)="toggle(COMPACT)" (keydown)="onToggleKeydown($event, COMPACT)">MENU</button>
        <div class="dropdown-menu sn-top-dropdown sn-top-dropdown--compact" [attr.data-sn-menu]="COMPACT">
          <ng-container *ngIf="vm.favorites?.length">
            <h6 class="dropdown-header sn-top-dropdown__heading">Favorites</h6>
            <ng-container *ngTemplateOutlet="favoriteItems; context: {$implicit: vm.favorites}"></ng-container>
            <div class="dropdown-divider"></div>
          </ng-container>
          <ng-container *ngTemplateOutlet="items; context: {$implicit: vm.main, vm: vm}"></ng-container>
        </div>
      </li>
    </ng-template>
  </ul>

  <!-- Off-screen copy of the top-level entries at their natural width, for the compact switch. -->
  <div class="nav-overflow-measure" aria-hidden="true" #measure>
    <span *ngIf="vm.favorites?.length" class="nav-overflow-measure__item">
      <span class="nav-link dropdown-toggle"><i class="fa-solid fa-star"></i></span>
    </span>
    <span *ngFor="let node of vm.main; trackBy: trackById" class="nav-overflow-measure__item">
      <span class="nav-link" [class.dropdown-toggle]="node.type === 'group'">{{ node.label | uppercase }}</span>
    </span>
  </div>

  <ng-template #items let-nodes let-vm="vm">
    <ng-container *ngFor="let node of nodes; trackBy: trackById">
      <div *ngIf="node.type === 'divider'" class="dropdown-divider" role="separator"></div>
      <ng-container *ngIf="node.type === 'group'">
        <h6 class="dropdown-header sn-top-dropdown__heading">{{ node.label }}</h6>
        <ng-container *ngTemplateOutlet="items; context: {$implicit: node.children, vm: vm}"></ng-container>
      </ng-container>
      <div *ngIf="node.type === 'link'" class="sn-top-dropdown__row">
        <a *ngIf="!node.external" class="dropdown-item" [class.sn-top-dropdown__item--active]="vm.activeIds.has(node.id)"
           [attr.aria-current]="vm.activeIds.has(node.id) ? 'page' : null"
           [routerLink]="node.path" [queryParams]="node.queryParams" (click)="closeAll()">
          <i class="fa-fw sn-top-dropdown__icon" [ngClass]="node.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>
          <span>{{ node.label }}</span>
        </a>
        <a *ngIf="node.external" class="dropdown-item" [href]="node.href" target="_blank" rel="noopener noreferrer"
           (click)="closeAll()">
          <i class="fa-fw sn-top-dropdown__icon" [ngClass]="node.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>
          <span>{{ node.label }}</span>
          <i class="fa-solid fa-arrow-up-right-from-square sn-top-dropdown__external" aria-hidden="true"></i>
          <span class="sr-only"> (opens in a new tab)</span>
        </a>
        <button type="button" class="sn-star" [class.sn-star--on]="isStarred(node, vm.starred)"
                [attr.aria-pressed]="isStarred(node, vm.starred)" [attr.aria-label]="'Favorite ' + node.label"
                [title]="isStarred(node, vm.starred) ? 'Remove from favorites' : 'Add to favorites'"
                (click)="toggleStar(node, $event)">
          <i [ngClass]="isStarred(node, vm.starred) ? 'fa-solid fa-star' : 'fa-regular fa-star'" aria-hidden="true"></i>
        </button>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #favoriteItems let-favorites>
    <div *ngFor="let favorite of favorites; let first = first; let last = last; trackBy: trackById"
         class="sn-top-dropdown__row sn-top-dropdown__row--favorite">
      <input *ngIf="renaming === favorite.key" #rename class="form-control form-control-sm sn-top-dropdown__rename"
             type="text" maxlength="120" [value]="favorite.label" [attr.aria-label]="'Rename ' + favorite.label"
             (click)="$event.stopPropagation()" (keydown.enter)="finishRename(favorite, rename.value)"
             (keydown.escape)="cancelRename($event)" (blur)="finishRename(favorite, rename.value)">
      <ng-container *ngIf="renaming !== favorite.key">
      <a *ngIf="!favorite.external" class="dropdown-item" [routerLink]="favorite.path"
         [queryParams]="favorite.queryParams" (click)="closeAll()">
        <i class="fa-fw sn-top-dropdown__icon" [ngClass]="favorite.icon || 'fa-solid fa-bookmark'" aria-hidden="true"></i>
        <span>{{ favorite.label }}</span>
        <small *ngIf="favorite.detail" class="sn-top-dropdown__detail">{{ favorite.detail }}</small>
      </a>
      <a *ngIf="favorite.external" class="dropdown-item" [href]="favorite.href" target="_blank"
         rel="noopener noreferrer" (click)="closeAll()">
        <i class="fa-fw sn-top-dropdown__icon" [ngClass]="favorite.icon || 'fa-solid fa-bookmark'" aria-hidden="true"></i>
        <span>{{ favorite.label }}</span>
        <span class="sr-only"> (opens in a new tab)</span>
      </a>
      <span class="sn-top-dropdown__actions">
        <button type="button" class="sn-icon-button" [attr.aria-label]="'Rename ' + favorite.label"
                title="Rename" (click)="startRename(favorite, $event)">
          <i class="fa-solid fa-pen" aria-hidden="true"></i>
        </button>
        <button type="button" class="sn-icon-button" [disabled]="first" [attr.aria-label]="'Move ' + favorite.label + ' up'"
                title="Move up" (click)="moveFavorite(favorite, -1, $event)">
          <i class="fa-solid fa-arrow-up" aria-hidden="true"></i>
        </button>
        <button type="button" class="sn-icon-button" [disabled]="last" [attr.aria-label]="'Move ' + favorite.label + ' down'"
                title="Move down" (click)="moveFavorite(favorite, 1, $event)">
          <i class="fa-solid fa-arrow-down" aria-hidden="true"></i>
        </button>
        <button type="button" class="sn-icon-button" [attr.aria-label]="'Remove ' + favorite.label + ' from favorites'"
                title="Remove from favorites" (click)="removeFavorite(favorite, $event)">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      </span>
      </ng-container>
    </div>
  </ng-template>
</ng-container>
